import { useEffect, useState } from "react";
import { getDesoProfileApi } from "../Network/network";

const GetDesoProfile = () => {
  const [username, setUsername] = useState("");

  let pub_key;
  if (localStorage.getItem("credential")) {
    pub_key = JSON.parse(localStorage.getItem("credential")).publicKeyAdded;
  }
  useEffect(() => {
    if (pub_key) {
      fetchData();
    }
  }, []);

  const fetchData = async () => {
    const response = await getDesoProfileApi({ public_key: pub_key });

    if (response?.Profile.Username) {
      console.log(response.Profile.Username);
      setUsername(response?.Profile.Username);
      localStorage.setItem("userName", response?.Profile.Username);
    } else {
      setUsername(null);
    }
  };
  return { username, setUsername };
};

export default GetDesoProfile;
